import { render, staticRenderFns } from "./ExhibitionsTable.vue?vue&type=template&id=6fb53b3e&"
import script from "./ExhibitionsTable.vue?vue&type=script&lang=js&"
export * from "./ExhibitionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports